import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { scrollToTop } from 'utils/Link';
import { getLang } from 'utils/Contentful';

import MenuItem from './MenuItem';
import * as localeMap from './locale';

class Header extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      lang: {},
      expandMenu: "",
      isOpenMenu: false,
    };
  }

  componentDidMount() {
    this.setLang(this.props.localeCode);
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.localeCode !== this.props.localeCode &&
       !this.state.lang[this.props.localeCode]
    ) {
      this.setLang(this.props.localeCode);
    }
  }

  setLang = localeCode => {
    getLang(localeCode, 'Link').then(lang => {
      this.setState({
        lang: {
          ...this.state.lang,
          [localeCode]: lang
        }
      });
    }).then(() => {
      getLang(localeCode, 'Method').then(lang => {
        this.setState({
          lang: {
            ...this.state.lang,
            [localeCode]: {
              ...this.state.lang[localeCode],
              method: Object.keys(lang).map(key => {
                return ({
                  text: lang[key].heading,
                  link: `/method/${key}`
                });
              }).sort((a, b) => a.link > b.link)
            }
          }
        });
      });
    });
  }

  toggleMenu = () => {
    this.setState({
      isOpenMenu: !this.state.isOpenMenu
    });
  }

  openSubMenu = expandMenu => {
    this.setState({
      expandMenu: this.state.expandMenu !== expandMenu ? expandMenu: ""
    });
  }

  render() {
    const {
      locale,
      params,
      location,
    } = this.props;
    const {
      expandMenu,
      isOpenMenu,
    } = this.state;
    let lang = localeMap[locale];

    const remoteLang = this.state.lang[this.props.localeCode];

    if(remoteLang && remoteLang.list) {
      lang.menuItem.links.list = remoteLang.list;
    }

    if(remoteLang && remoteLang.method) {
      lang.menuItem.method.list = remoteLang.method;
    }

    const pathname = params.locale ? location.pathname: `/${locale}${location.pathname}`;
    return (
      <div className="header">
        <div className="fixed">
          <div className="container">
            <Link onClick={scrollToTop} to={`/${locale}`} className="logo">logo</Link>
            <span className="com-name">{lang.comName}</span>
            <div className="divider" />
            <ul>
              {Object.keys(lang.menuItem).map(item =>
                <li key={item}>
                  <MenuItem item={item} locale={locale} {...lang.menuItem[item]} />
                </li>
              )}
              {lang.langList.map(item =>
                <li key={item.locale}>
                  <Link id="lang" to={pathname.replace(locale, item.locale)}>
                    {item.text}
                  </Link>
                </li>
              )}
            </ul>
            <div className="mt-dropdown-menu">
              <span
                onClick={this.toggleMenu}
                className={isOpenMenu ? "ion-close": "ion-android-menu"}
              />
              {
                isOpenMenu &&
                <ul>
                  {Object.keys(lang.menuItem).map(item =>
                    <li key={`mt-${item}`} onClick={() => this.openSubMenu(item)}>
                      <MenuItem active={expandMenu === item} locale={locale} {...lang.menuItem[item]} />
                    </li>
                  )}
                  {lang.langList.map(item =>
                    <li key={item.locale}>
                      <Link to={pathname.replace(locale, item.locale)}>
                        {item.text}
                      </Link>
                    </li>
                  )}
                </ul>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;

Header.propTypes =  {
  menuItem: PropTypes.object
};

Header.propTypes = {
  params: () => {},
  location: () => {},
};



// WEBPACK FOOTER //
// ./src/components/Header/index.js